
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorBase } from '@/components/a-interfaz/a-controlador';
    import { } from '@/components/a-interfaz/a-controlador';
import { ControladorDeAutenticacion} from '@/__env/shared/login/autenticar';
import { Utiles } from '@/__env/pluggins/event-bus';
import { settings } from '@/__env/ext';


    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        public Abierto: boolean = false;
        @Prop() public Controlador: ControladorBase;
        public get Usuario() { return this.Controlador.Usuario; };

        public Cargando: boolean = false;
        async CerrarSesion()
        {
            if ( ! await Utiles.Mensajes.SiNo( 'Cerrar sesión', '¿Cerrar la sesión del sistema?' ) )
                return;
            this.Cargando = true;
            let e = await ControladorDeAutenticacion.CerrarSesion();
            if ( e )
            {

                window.location.href = settings.URL.host;
                //this.$router.push( '/login' );
            }
            else
            {
                Utiles.Notificaciones.Error( 'Error al cerrar la sesión' );
            }
            this.Cargando = false;
        }
    }
